export const reports = "/newreports/";
export var EConsolidated;
(function (EConsolidated) {
    EConsolidated["CONSOLIDATED"] = "Consolidated";
    EConsolidated["YOU"] = "You";
})(EConsolidated || (EConsolidated = {}));
export const createSortName = (memberFullName) => {
    var _a, _b;
    let names = (_b = (_a = memberFullName === null || memberFullName === void 0 ? void 0 : memberFullName.split(" ")) === null || _a === void 0 ? void 0 : _a.filter((name) => !!name)) !== null && _b !== void 0 ? _b : [];
    if (names.length >= 3)
        return (names[0][0] + names[2][0]).toUpperCase();
    else if (names.length === 2)
        return (names[0][0] + names[1][0]).toUpperCase();
    else if (names.length === 1)
        return names[0][0].toUpperCase();
};
export var EelementId;
(function (EelementId) {
    EelementId["REPORT_NAVBAR"] = "report-navbar";
})(EelementId || (EelementId = {}));
export const consolidated = {
    head: "",
    accCode: EConsolidated.CONSOLIDATED,
    permission: "",
    role: "",
    memberName: EConsolidated.CONSOLIDATED,
};
